window.__pt = window.__pt || {};
window.__pt.ln = window.__pt.ln || {};
window.__pt.settings = window.__pt.settings || {};

/** Dates */
window.__pt.settings.formatBoxDate = "DD MMM YYYY";
window.__pt.settings.formatBoxDateMobile = "DD MMM";
window.__pt.settings.formatDate = "yyyy-MM-dd";
window.__pt.settings.formatMomentDate = "YYYY-MM-DD";
window.__pt.settings.formatDateSlash = "dd/MMM/yyyy";
window.__pt.settings.formatDateSlashBook = "dd/MMMM/yyyy";
window.__pt.ln = {
    yourSelectionIncludes: "Tu selección incluye {0}<br> {1} de las {2} <br>solicitadas en tu búsqueda.<br>Te sugerimos revisar tu selección",
    uriHotels: "/hoteles",
    and: "y",
    continue: 'Continuar',
    total: "Total",
    nights: "noches",
    night: "noche",
    nightm: "noche",
    nighstm: "noches",
    person: "persona",
    persons: "personas",
    pay: 'Realizar reserva',
    adult: 'adulto',
    adults: 'adultos',
    persons: 'personas',
    person: 'persona',
    child: 'menor',
    children: 'menores',
    the: 'de',
    years: 'años',
    year: 'año',
    minore: 'niño',
    minores: 'niños',
    room: 'habitación',
    rooms: 'habitaciones',
    selecteds: "seleccionadas",
    selected: "seleccionada",
    for: "para",
    fora: "por",
    free: 'Gratis',
    locale_lang: "es",
    locale: 'es-es',
    loading: 'loading..',
    ok: 'Aceptar',
    cancel: 'Cancelar',
    capacity: 'Máximo {0} persona',
    kidsFreeTo: 'de 0 a {0} años',
    errorLogin: "Ocurrió un error inesperado.",
    errorVerification: "Ocurrió un error inesperado durante la verificación del correo electrónico.",
    errorConfigSesion: "Ocurrió un error inesperado durante la configuración de la sesión.",
    errorDeletingAccount: "Error al eliminar la cuenta: Error deleting account: ",
    noUserLoggedIn: "No hay ningún usuario conectado actualmente.",
    errorSendingPasswordResetEmail: "Error al enviar el correo de restablecimiento de contraseña.",
    errorSigningOut: "Error al cerrar sesión:",
    errorResendingVerificationEmail: "Error al reenviar el correo de verificación:",
    rating: {
        "10": "Excelente",
        "9": "Sobresaliente",
        "8": "Muy Bueno",
        "7": "Bueno",
        "default": "Conveniente",
    },
    rating_reviews: {
        "1": "Terrible",
        "2": "Malo",
        "3": "Aceptable",
        "4": "Bueno",
        "5": "Excelente",
    },
    rating_reviews_range: [
        {
            "display": "Excepcional",
            "range": [9.6, 10.0]
        },
        {
            "display": "Magnífico",
            "range": [9.0, 9.5]
        },
        {
            "display": "Excelente",
            "range": [8.6, 8.9]
        },
        {
            "display": "Muy Bueno",
            "range": [8.0, 8.5]
        },
        {
            "display": "Bueno",
            "range": [7.0, 7.9]
        },
        {
            "display": "Aceptable",
            "range": [6.0, 6.9]
        },
        {
            "display": "Malo",
            "range": [0.1, 5.9]
        }
    ],
    promotions_keys: {
        "21": "Oferta entre semana",
        "16": "Hot Sale",
        "115": "Oferta Buen Fin"
    },
    hotel_lang: "Hotel",
    flight_round_pricetravel: "Vuelo redondo",
    flight_round_tiquetesbaratos: "Vuelo de ida y regreso",
    flight_one_way_pricetravel: "Vuelo sencillo",
    flight_one_way_tiquetesbaratos: "Vuelo solo de ida",
    package_lang: "Hotel + Vuelo",
    new_room: "hab.",
    new_pers: "pers.",
    all_options: "Todas las opciones",
    price_calendar_footer: "Precios aproximados en {currency} por noche para 2 adultos",
    day: "dia",
    days: "dias",
    low_prices: "Precios bajos",
    lower_prices: "Precios más bajos",
};

window.__pt.ln.availabilityMessages = {
    "minimumstay": {
        "title1": "Habitaciones con mínimo de estancia",
        "title2": "Intenta reservando un mínimo de {{days}} noches"
    },
    "maximumstay": {
        "title1": "Habitaciones con máximo de estancia.",
        "title2": "Intenta reservando un máximo de {{days}} noches"
    },
    "none": {
        "title1": "Sin disponibilidad para estas fechas",
        "title2": "Intenta consultando otras fechas o llama sin costo"
    },
    "peoplemax": {
        "title1": "Capacidad máxima de huéspedes",
        "title2": "Intenta cambiando el número de personas o de habitaciones"
    },
    "adultsmax": {
        "title1": "Superas el límite de adultos por habitación",
        "title2": "Intenta cambiando el número de habitaciones"
    },
    "kidsmax": {
        "title1": "Superas el límite de niños por habitación",
        "title2": "Intenta cambiando el número de personas o de habitaciones"
    },
    "kidszero": {
        "title1": "Superas el límite de niños por habitación",
        "title2": "Intenta seleccionando solo adultos"
    },
    "defaults": { "minimumstay": 5, "maximumstay": 30 }
};

window.__pt.ln.mealplans = {
    "A": "Desayuno americano",
    "AA": "Navidad y Fin de Año Imperial",
    "AB": "Escapada Romántica",
    "AC": "Escapada Romántica y Spa",
    "AD": "Comida y cena con bebidas incluidas",
    "AE": "Desayuno (solo adultos)",
    "AF": "Desayuno Gourmet Americano",
    "AG": "Desayuno para 2",
    "AH": "Desayuno Continental para 2",
    "AI": "Desayuno y Almuerzo",
    "AJ": "Desayuno, almuerzo, cena, con liquidos",
    "AK": "Semi todo incluido",
    "AL": "3 comidas + 2 snacks",
    "AM": "Dining Plan",
    "AN": "Quick Service",
    "AO": "Desayuno, comida o cena, sin líquidos",
    "AP": "Desayuno, merienda y cena",
    "AQ": "Desayuno, almuerzo o cena",
    "AR": "No Reembolsable",
    "AS": "Bebidas Incluidas",
    "AT": "Desayuno, comida y cena solo adultos",
    "AU": "Desayuno continental solo adultos",
    "AV": "Desayuno – no reembosable",
    "AW": "Alimentos, Bebidas y Tours Incluidos",
    "AX": "Desayuno para 1 adulto",
    "AY": "Cena",
    "AZ": "Todo Incluido",
    "B": "Desayuno bufet",
    "BA": "Premium",
    "C": "Comida",
    "E": "Solo alojamiento",
    "F": "Desayuno y cena incluidos",
    "G": "Desayuno, comida y cena",
    "H": "Desayuno, comida o cena",
    "I": "Todo incluido",
    "J": "Desayuno bufet continental",
    "K": "Alimentos y bebidas incluidas",
    "L": "Desayuno",
    "M": "Desayuno y cena con bebidas incluidas",
    "N": "Desayuno sin líquidos",
    "O": "Barra libre",
    "P": "Desayuno y cena, sin liquidos",
    "Q": "Desayuno, almuerzo y cena, sin liquidos",
    "R": "Desayuno bufet sin bebidas",
    "S": "Desayuno y comida o cena, sin líquidos",
    "T": "Comida sin líquidos",
    "U": "2 comidas quick service + 1 snack",
    "V": "2 comidas + 1 snack",
    "W": "3 alimentos sin bebidas",
    "X": "Cena sin líquidos",
    "Y": "Desayuno continental sin líquidos",
    "Z": "Desayuno continental",
    "AR": "Solo alojamiento",
    "BA": "Alimentos y bebidas Premium",
    "BB": "Crédito del resort incluido",
    "BZ": "Desayuno bufet",
    "EL": "Solo alojamiento con promoción",
    "GR": "Desayuno, comida y cena",
    "HR": "Desayuno, comida o cena",
    "KR": "Alimentos y bebidas incluidas",
    "MR": "Desayuno y cena con bebidas",
    "PR": "Desayuno y Cena",
    "XB": "Golf AM - Desayuno bufet",
    "XE": "Golf AM - Solo alojamiento",
    "ZA": "Desayuno americano",
    "ZR": "Desayuno continental",
};

window.__pt.ln.freecancellation = {
    "notallowed": "No reembolsable",
    "allowed": "Cancelación gratis",
};

window.__pt.ln.promotion = {
    "40%dedescuento+2niñosgratis": "40% de descuento + 2 niños gratis",
    "ventaespecial": "Venta especial",
    "ofertadeverano": "Oferta de verano",
    "promociónelbuenfin": "Promoción de Buen Fin",
    "blackfriday": "Black Friday",
    "20-30": "20% de descuento",
    "30-40": "30% de descuento",
    "40-50": "40% de descuento",
    "50-100": "Desde 50% de descuento",
    "hotsale": "Hot sale"
};
window.__pt.ln.paymentmethods = {
    "2": "Paga en el alojamiento"
}
window.__pt.ln.stars = {
    "5": "5 estrellas",
    "4": "4 estrellas",
    "3": "3 estrellas",
    "2": "2 estrellas",
    "1": "1 estrella"
};

window.__pt.ln.reviews = {
    "dwonderful": "Magnífico: 9 o más",
    "bverygood": "Muy Bueno: 8 o más",
    "agood": "Bueno: 7 o más"
};
window.__pt.ln.filterslang = {
    "zones": "zonas",
    "amenities": "amenidades",
    "room-view": "vista-de-la-habitacion",
    "interest": "interes"
};
window.angular.module("ngLocale", [], ["$provide", function ($provide) {
    var PLURAL_CATEGORY = { ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other" };
    $provide.value("$locale", {
        "DATETIME_FORMATS": {
            "AMPMS": [
                "a.m.",
                "p.m."
            ],
            "DAY": [
                "domingo",
                "lunes",
                "martes",
                "mi\u00e9rcoles",
                "jueves",
                "viernes",
                "s\u00e1bado"
            ],
            "ERANAMES": [
                "antes de Cristo",
                "despu\u00e9s de Cristo"
            ],
            "ERAS": [
                "a. C.",
                "d. C."
            ],
            "FIRSTDAYOFWEEK": 0,
            "MONTH": [
                "enero",
                "febrero",
                "marzo",
                "abril",
                "mayo",
                "junio",
                "julio",
                "agosto",
                "septiembre",
                "octubre",
                "noviembre",
                "diciembre"
            ],
            "SHORTDAY": [
                "dom.",
                "lun.",
                "mar.",
                "mi\u00e9.",
                "jue.",
                "vie.",
                "s\u00e1b."
            ],
            "SHORTMONTH": [
                "Ene.",
                "Feb.",
                "Mar.",
                "Abr.",
                "May.",
                "Jun.",
                "Jul.",
                "Ago.",
                "Sep.",
                "Oct.",
                "Nov.",
                "Dic."
            ],
            "STANDALONEMONTH": [
                "enero",
                "febrero",
                "marzo",
                "abril",
                "mayo",
                "junio",
                "julio",
                "agosto",
                "septiembre",
                "octubre",
                "noviembre",
                "diciembre"
            ],
            "WEEKENDRANGE": [
                5,
                6
            ],
            "fullDate": "EEEE, d 'de' MMMM 'de' y",
            "longDate": "d 'de' MMMM 'de' y",
            "medium": "d MMM y HH:mm:ss",
            "mediumDate": "d MMM y",
            "mediumTime": "HH:mm:ss",
            "short": "d/M/yy HH:mm",
            "shortDate": "d/M/yy",
            "shortTime": "HH:mm"
        },
        "NUMBER_FORMATS": {
            "CURRENCY_SYM": "$",
            "DECIMAL_SEP": ".",
            "GROUP_SEP": ",",
            "PATTERNS": [
                {
                    "gSize": 3,
                    "lgSize": 3,
                    "maxFrac": 3,
                    "minFrac": 0,
                    "minInt": 1,
                    "negPre": "-",
                    "negSuf": "",
                    "posPre": "",
                    "posSuf": ""
                },
                {
                    "gSize": 3,
                    "lgSize": 3,
                    "maxFrac": 2,
                    "minFrac": 2,
                    "minInt": 1,
                    "negPre": "-\u00a4",
                    "negSuf": "",
                    "posPre": "\u00a4",
                    "posSuf": ""
                }
            ]
        },
        "id": "es-419",
        "localeID": "es_419",
        "pluralCat": function (n, opt_precision) { if (n == 1) { return PLURAL_CATEGORY.ONE; } return PLURAL_CATEGORY.OTHER; }
    });
}]);


window.__pt.settings.loginErrors = {
  "auth/account-exists-with-different-credential": "El correo electrónico ya está en uso con diferentes credenciales",
  "auth/email-already-in-use": "La dirección de correo electrónico ya está en uso por otra cuenta",
  "auth/invalid-email": "La dirección de correo electrónico tiene un formato incorrecto",
  "auth/operation-not-allowed": "La operación no está permitida",
  "auth/weak-password": "Contraseña muy débil",
  "auth/auth-domain-config-required": "Proveedor no autorizado",
  "auth/cancelled-popup-request": "Se ha cancelado el inicio de sesión",
  "auth/operation-not-supported-in-this-environment": "El inicio de sesión con contraseña está deshabilitado para este proyecto",
  "auth/user-disabled": "La cuenta de usuario ha sido deshabilitada por un administrador",
  "auth/user-not-found": "No hay ningún registro de usuario correspondiente a este correo",
  "auth/wrong-password": "La contraseña es inválida o el usuario no tiene contraseña",
  "auth/too-many-requests": "Hemos bloqueado todas las solicitudes por actividad inusual. Inténtalo más tarde",
  "auth/invalid-verification-code": "Código de verificación inválido",
  "auth/invalid-verification-id": "ID de verificación inválido",
  "auth/missing-verification-code": "Falta el código de verificación",
  "auth/missing-verification-id": "Falta el ID de verificación",
  "auth/credential-already-in-use": "La credencial ya está en uso",
  "auth/expired-action-code": "El enlace de {0} ha expirado",
  "auth/invalid-action-code": "El enlace de {0} es inválido",
  "auth/invalid-credential": "Credencial inválida",
  "auth/invalid-phone-number": "Formato de teléfono inválido",
  "auth/missing-phone-number": "Falta el número de teléfono",
  "auth/quota-exceeded": "Límite de cuota excedido",
  "auth/timeout": "Tiempo de espera agotado",
  "auth/provider-already-linked": "El proveedor ya está vinculado",
  "auth/requires-recent-login": "Requiere autenticación reciente",
  "auth/unauthorized-domain": "Dominio no autorizado",
  "auth/invalid-api-key": "API key inválida",
  "auth/network-request-failed": "Error de red",
  "action_type/reset": "restablecimiento de contraseña",
  "action_type/verify": "verificación de correo"
}

window.__pt.ln.overriteTitles = {
    "Amenidades": "Instalaciones y servicios"
}

window.__pt.ln.paths = {
    "listPath": "hoteles-en-",
};
